import {updateUser} from 'shared/portfolio/actions/student';

export const skipChecklistItem = (itemId) => (dispatch, getState) => {
  const {student} = getState();
  return dispatch(
    updateUser({
      skippedChecklistItems: (student.skippedChecklistItems || []).concat(itemId),
    })
  );
};
